import { apiSlice } from '../apiSlice'

export const breakDownApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrMonthReport: builder.query({
      query: ({createdBy}) => `/dashboard/current-month-summary?createdBy=${createdBy}`,
      keepUnusedDataFor: 600,
      providesTags: () => [{ type: 'currMonthSalesSummary' }],
    }),
    getLastMonthReport: builder.query({
      query: ({createdBy}) => `/dashboard/last-month-summary?createdBy=${createdBy}`,
      keepUnusedDataFor: 600,
      providesTags: () => [{ type: 'lastMonthSalesSummary' }],
    }),
    getThreeMonthsReport: builder.query({
      query: ({createdBy}) => `/dashboard/three-month-summary?createdBy=${createdBy}`,
      keepUnusedDataFor: 600,
      providesTags: () => [{ type: 'threeMonthSalesSummary' }],
    }),
  }),
  
})

export const {
  useGetCurrMonthReportQuery,
  useGetLastMonthReportQuery,
  useGetThreeMonthsReportQuery,
} = breakDownApi
